import React from 'react';

import '../style.scss';

export const InputArea = () => {
  return (
    <div className="input-area-skeleton">
      <div className="skeleton">
        <div>
          <div className="title skeleton-square"></div>
        </div>
      </div>
    </div>
  );
};
